module.exports = __webpack_public_path__ + "static/media/garbageTruck_salmon.bab97456.svg";